// extracted by mini-css-extract-plugin
export default {"subTitile":"PaymentSuccess_subTitile__KXrnL","image":"PaymentSuccess_image__kqaAb","linkButtons":"PaymentSuccess_linkButtons__mxIB7","button":"PaymentSuccess_button__vd56R"};